import { FC } from 'react';
import { Box, Typography } from '@mui/material';

type PaymentSummaryCardProps = {
  title: string;                // "Vendidas por RRPP" / "Vendidas por Productor" / etc.
  totalLabel?: string;          // Texto "Total" (por defecto "Total")
  totalQuantity: number | string; // Cantidad total (ya formateada o cruda)
  totalAmount: number | string;   // Monto total (ya formateado o crudo)
  accentColor: string;          // Color principal para los números (ej: #FFA31A, #FF1A43, etc.)
  onClick?: () => void;         // Opcional, por si alguna card es clickeable (Productor en Figma)
};

const PaymentSummaryCard: FC<PaymentSummaryCardProps> = ({
  title,
  totalLabel = 'Total',
  totalQuantity,
  totalAmount,
  accentColor,
  onClick
}) => {
  const isClickable = Boolean(onClick);

  return (
    <Box
      onClick={onClick}
      sx={{
        width: 232,
        height: 98,
        borderRadius: '16px',
        bgcolor: '#FFFFFF',
        boxShadow: '0px 8px 24px rgba(15, 23, 42, 0.08)',
        padding: '12px 16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        '&:hover': isClickable
          ? {
              transform: 'translateY(-2px)',
              boxShadow: '0px 12px 32px rgba(15, 23, 42, 0.12)'
            }
          : undefined
      }}
    >
      {/* Título: "Vendidas por RRPP", etc. */}
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 500,
          lineHeight: '24px',
          letterSpacing: '0.09px',
          color: '#223354'
        }}
      >
        {title}
      </Typography>

      {/* Bloque "Total: X" */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: 12,
            lineHeight: '19px'
          }}
        >
          {totalLabel}:
        </Typography>

        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            lineHeight: '19px',
            color: accentColor
          }}
        >
          {totalQuantity}
        </Typography>
      </Box>

      {/* Monto total */}
      <Typography
        variant="body1"
        sx={{
          fontWeight: 700,
          lineHeight: '100%',
          textAlign: 'right',
          color: accentColor
        }}
      >
        {totalAmount}
      </Typography>
    </Box>
  );
};

export default PaymentSummaryCard;
